module.exports = __webpack_public_path__ + "img/265.23bb4672.png";